import { UserProfileDTO } from '@/../client-generator/generated-clients/user';
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import TheHeaderDropdownAccnt from '../TheHeaderDropdownAccnt.vue';

export default defineComponent({
  name: 'TheHeader',

  components: {
    TheHeaderDropdownAccnt,
  },

  computed: {
    ...mapState(['profile']),
    ...mapGetters(['isAdmin']),

    userName(): string {
      const profile = (this as any).profile as UserProfileDTO | null;
      if (!profile) return '';
      if (profile.firstName === profile.username && profile.lastName === profile.username) {
        return profile.username!;
      }
      if (profile.firstName) {
        return `${profile.firstName} ${profile.lastName}`;
      }
      return profile.username!;
    },
  },
});
